/**
 * Small standalone query keys that don't warrant their own domain file (Server-state
 * rebuild, P4-tail): current user, user list, signature, notifications, auditor-firm team,
 * and assertions. Preserves today's exact values.
 */
export const miscKeys = {
  user: () => ['user'] as const,
  allUsers: () => ['all-users'] as const,
  signature: () => ['signature'] as const,
  notifications: (scope: string) => ['notifications', scope] as const,
  team: () => ['team'] as const,
  teamAuditorFirms: () => ['team', 'auditor-firms'] as const,
  assertions: (auditId?: string) => ['assertions', auditId] as const,
} as const;
